import { useEffect, useMemo, useRef, useState } from "react";
import {
  MeetingProvider,
  MeetingConsumer,
  useMeeting,
  useParticipant,
  // createCameraVideoTrack,
  // Constants,
} from "@videosdk.live/react-sdk";
import Credin from "../../../../../../../../../assets/Credin Logo (1).svg";
import styles from "./VideoPage.module.css";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import CloseIcon from "@mui/icons-material/Close";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import { usePubSub } from "@videosdk.live/react-sdk";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import axios from 'axios';
import { url } from "../../../../../../../../../App";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { createCameraVideoTrack } from "@videosdk.live/react-sdk";

function JoinScreen({ getMeetingAndToken }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");
  const loanId = queryParams.get("loanId");
  const id = queryParams.get("meetingId");
  const userName = queryParams.get("Username");
  const customerName = name;
  const [meetingId, setMeetingId] = useState(id);
  const onClick = async () => {
    await getMeetingAndToken(meetingId, customerName, loanId, userName);
  };

  return (
    <div className={styles.joinScreen}>
      <img src={Credin} alt="Credin Logo" />
      <input
        type="text"
        placeholder="Enter Meeting Id"
        value={meetingId}
        onChange={(e) => setMeetingId(e.target.value)}
        className={styles.input}
      />
      <button onClick={onClick} className={styles.button}>
        Join
      </button>
    </div>
  );
}
function ParticipantView({ participantId, className, onClick, customerName, userName }) {
  const micRef = useRef(null);
  const videoRef = useRef(null);
  const { webcamStream, micStream, webcamOn, micOn, isLocal, getAudioStats, getVideoStats } = useParticipant(participantId);
  const { publish } = usePubSub("bitrate");
  const { publish: publishConsent } = usePubSub("user_consent");

  useEffect(() => {
    publishConsent(
      "User Consent",
      { persist: false },
      { consent: true }
    );
  }, [publishConsent]);

  const videoStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
    return null;
  }, [webcamStream, webcamOn]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
        micRef.current.srcObject = mediaStream;
        micRef.current.play().catch((error) => {
          console.error("micRef.current.play() failed", error);
        });
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn]);

  useEffect(() => {
    if (videoRef.current) {
      if (webcamOn && videoStream) {
        videoRef.current.srcObject = videoStream;
        videoRef.current.play().catch((error) => {
          console.error("videoRef.current.play() failed", error);
        });
      } else {
        videoRef.current.srcObject = null;
      }
    }
  }, [videoStream, webcamOn]);

  useEffect(() => {
    if (isLocal) {
      const interval = setInterval(async () => {
        try {
          const [videoStats, audioStats] = await Promise.all([
            getVideoStats(),
            getAudioStats(),
          ]);
          const videoBitrate = videoStats?.[0]?.bitrate || 0;
          const audioBitrate = audioStats?.[0]?.bitrate || 0;
          const total = ((videoBitrate + audioBitrate) / 1000).toFixed(1);
          publish({ participantId, bitrate: total }, { persist: false });
        } catch (error) {
          console.error("Customer bitrate publish error:", error);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isLocal, getAudioStats, getVideoStats, publish, participantId]);

  return (
    <div
      key={participantId}
      className={`${styles.participant} ${className}`}
      onClick={() => onClick(participantId)}
    >
      <p className={styles.participantInfo}>
        {isLocal ? userName : customerName}: Webcam: {webcamOn ? "ON" : "OFF"} | Mic: {micOn ? "ON" : "OFF"}
      </p>

      <audio ref={micRef} autoPlay muted={isLocal} />
      {webcamOn && (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted={true}

          style={{ width: "100%", height: "100%", objectFit: "cover", imageRendering: "auto", }}
          onError={(err) => {
            console.log(err, "participant video error");
          }}
        />
      )}
    </div>
  );
}
function Controls({ loanId }) {
  const {
    localParticipant,
    toggleMic,
    toggleWebcam,
    leave,
    getWebcams,
    changeWebcam,
  } = useMeeting();

  const [micEnabled, setMicEnabled] = useState(localParticipant?.micOn);
  const [webcamEnabled, setWebcamEnabled] = useState(localParticipant?.webcamOn);
  const [cameras, setCameras] = useState([]);
  const [location, setLocation] = useState({ lat: null, lng: null });
  // eslint-disable-next-line
  const [address, setAddress] = useState("");
  // eslint-disable-next-line
  const [selectedCamera, setSelectedCamera] = useState(null);
  const lastLocation = useRef({ lat: null, lng: null });
  const { publish } = usePubSub('user_address');

  useEffect(() => {
    setMicEnabled(localParticipant?.micOn);
    setWebcamEnabled(localParticipant?.webcamOn);
  }, [localParticipant?.micOn, localParticipant?.webcamOn]);

  useEffect(() => {
    const handleGetWebcams = async () => {
      try {
        // Force permission first
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

        const webcams = await getWebcams();

        // Extra fallback if device labels are empty
        if (!webcams || webcams.length === 0) {
          toast.error("No cameras found.");
          return;
        }

        setCameras(webcams);

        // Default to first camera
        if (webcams.length > 0) {
          setSelectedCamera(webcams[0].deviceId);
        }

      } catch (err) {
        console.error("Error getting cameras:", err);
        toast.error("Could not access cameras. Please check permissions.");
      }
    };

    handleGetWebcams();
    // eslint-disable-next-line
  }, []);

  const handleFlipCamera = () => {
    if (cameras.length < 2) {
      toast.error("Only one camera available.");
      return;
    }
    const currentIndex = cameras.findIndex(
      (cam) => cam.deviceId === selectedCamera
    );

    const nextIndex = (currentIndex + 1) % cameras.length;
    const nextCamera = cameras[nextIndex];

    // console.log(nextIndex,"nextIndex")
    // console.log(nextCamera,"nextCamera")

    if (nextCamera) {
      changeWebcam(nextCamera.deviceId);
      setSelectedCamera(nextCamera.deviceId);
    }
  };

  useEffect(() => {
    let watchId;
    if (navigator.geolocation) {
      watchId = navigator.geolocation.watchPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.error("Error getting location: ", error);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }

    // Cleanup to stop watching when component unmounts
    return () => {
      if (navigator.geolocation && watchId !== undefined) {
        navigator.geolocation.clearWatch(watchId);
      }
    };
  }, []);

  useEffect(() => {
    const fetchLocationFromBackend = async () => {
      if (
        location.lat &&
        location.lng &&
        (location.lat !== lastLocation.current.lat ||
          location.lng !== lastLocation.current.lng)
      ) {
        try {
          const response = await axios.post(url + '/videosdk/location', {
            latitude: location.lat,
            longitude: location.lng,
            loanId: loanId,
          });
          publish(
            "User address",
            { persist: false },
            {
              lat: location.lat,
              lng: location.lng
            }
          );
          setAddress(response.data.address);
          lastLocation.current = location;
        } catch (error) {
          toast.error("Error fetching location details from backend");
        }
      }
    };

    fetchLocationFromBackend();
  }, [publish, location, loanId]);

  const handleToggleMic = async () => {
    try {
      setMicEnabled((prevState) => !prevState);
      await toggleMic();
    } catch (error) {
      console.error("Failed to toggle mic", error);
    }
  };

  const handleToggleWebcam = async () => {
    try {
      setWebcamEnabled((prevState) => !prevState);
      const track = await createCameraVideoTrack({
        encoderConfig: "h1080p_w1440p",
        optimizationMode: "motion",
      });
       toggleWebcam(track);
    
    } catch (error) {
      console.error("Failed to toggle webcam", error);
    }
  };

  return (
    <div className={styles.controls}>
      <button
        onClick={leave}
        className={styles.btn}
        style={{ backgroundColor: "#f54343" }}
      >
        <CloseIcon />
      </button>
      <button
        onClick={handleToggleMic}
        className={styles.btn}
        style={{ backgroundColor: "#034ea1" }}
      >
        {micEnabled ? <MicIcon /> : <MicOffIcon />}
      </button>
      <button
        onClick={handleToggleWebcam}
        className={styles.btn}
        style={{ backgroundColor: "#034ea1" }}
      >
        {webcamEnabled ? <VideocamIcon /> : <VideocamOffIcon />}
      </button>

      <button
        className={styles.btn}
        style={{ backgroundColor: "#034ea1" }}
        onClick={handleFlipCamera}
      >
        <FlipCameraAndroidIcon />
      </button>

    </div>
  );
}
function MeetingView(props) {
  // console.log(props);
  const [joined, setJoined] = useState(null);
  const [messaged, setMessaged] = useState(false);
  const [message, setMessage] = useState("");
  const {
    toggleWebcam,
  } = useMeeting({
    webcamConfig: {
      resolution: "fullhd", // "sd" | "hd" | "fullhd"
      optimizationMode: "motion",
    },
  });

  usePubSub("")
  function onMessageReceived(message) {
    // console.log('New Message:', message);
    setMessage(message.message);
    setMessaged(true);
  }

  function onOldMessagesReceived(messages) {
    console.log('Old Messages:', messages);
  }
  // eslint-disable-next-line
  const { publish, messages } = usePubSub('CONTROL_WEBCAM', {
    onMessageReceived,
    onOldMessagesReceived,
  });


  const { join, participants, localParticipant } = useMeeting({
    onMeetingJoined: () => {
      setJoined("JOINED");
    },
    onMeetingLeft: () => {
      props.onMeetingLeave();
    },
  });

  const [localPartId, setLocalPartId] = useState(null);
  const [otherPartIds, setOtherPartIds] = useState([]);

  useEffect(() => {
    if (localParticipant) {
      setLocalPartId(localParticipant.id);
      setOtherPartIds(
        Array.from(participants.keys()).filter(
          (participantId) => participantId !== localParticipant.id
        )
      );
    }
  }, [localParticipant, participants]);

  const joinMeeting = () => {
    setJoined("JOINING");
    join();
  };

  const handleParticipantClick = (participantId) => {
    setLocalPartId(participantId);
    setOtherPartIds((prevOtherPartIds) =>
      prevOtherPartIds.map((id) => (id === participantId ? localPartId : id))
    );
  };
  const handleClose = () => {
    setMessaged(false);
  };
  const handleAccept = async () => {
    const track = await createCameraVideoTrack({
      encoderConfig: "h1080p_w1440p",
      optimizationMode: "motion",
    });
    toggleWebcam(track);
    setMessaged(false);
  }
  return (
    <div className={styles.container}>
      <img src={Credin} alt="Credin Logo" />
      <h3>Meeting Id: {props.meetingId}</h3>
      {joined && joined === "JOINED" ? (
        <div className={styles.meeting}>
          {localPartId && (
            <ParticipantView
              key={localPartId}
              participantId={localPartId}
              className={styles.localParticipant}
              onClick={handleParticipantClick}
              customerName={props.customerName}
              userName={props.userName}
            />
          )}
          {messaged && <Dialog open={messaged}>
            <DialogTitle>{message}</DialogTitle>
            <DialogActions>
              <Button onClick={handleClose}>Disagree</Button>
              <Button onClick={handleAccept} autoFocus>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
          }
          <div className={styles.otherParticipantsContainer}>
            {otherPartIds.map((participantId) => (
              <ParticipantView
                key={participantId}
                participantId={participantId}
                className={styles.otherParticipant}
                onClick={handleParticipantClick}
                customerName={props.customerName}
                userName={props.userName}
              />
            ))}
          </div>
          <Controls loanId={props.loanId} />
          <ToastContainer position="top-right"
            autoClose={2000} />
        </div>
      ) : joined && joined === "JOINING" ? (
        <p>Joining the meeting...</p>
      ) : (
        <button onClick={joinMeeting} className={styles.button}>
          Join
        </button>
      )}
    </div>
  );
}
function App() {
  const [meetingId, setMeetingId] = useState(null);
  const [customerName, setCustomerName] = useState(null);
  const [userName, setUserName] = useState(null);
  const [loanId, SetLoanId] = useState(null);
  const authToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJjNDk0NzY0YS0xZThkLTRkMzEtOWFjZi1hYWM2ZTEwNWVhZTYiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTcyNTk0Mzk0NywiZXhwIjoxODgzNzMxOTQ3fQ.V4ltz2lFsjvBd5HkuRDvKy__KP5sBnkz5SUCoewuKUs";

  const getMeetingAndToken = async (id, name, loanId, userName) => {
    const meetingId = id;
    setMeetingId(meetingId);
    setCustomerName(name);
    setUserName(userName);
    SetLoanId(loanId);
  };

  const onMeetingLeave = () => {
    setMeetingId(null);
    setCustomerName(null);
  };
  // const getTrack = async (facingMode = "user") => {
  //   const track = await createCameraVideoTrack({
  //     facingMode,
  //     encoderConfig: "h1440p_w1920p" ,
  //     multiStream: false,
  //     optimizationMode: "motion",
  //   });
  //   setCustomTrack(track);
  // };



  // let [customTrack, setCustomTrack] = useState();

  // useEffect(() => {
  //   getTrack();
  // }, []);

  return authToken && meetingId ? (
    <MeetingProvider
      config={{
        meetingId,
        micEnabled: true,
        webcamEnabled: true,
        defaultCamera: "front",
        name: customerName || "Customer",
        maxResolution: "hd",
        // customCameraVideoTrack: customTrack,
      }}
      token={authToken}
    >
      <MeetingConsumer>
        {() => (
          <MeetingView meetingId={meetingId} loanId={loanId} onMeetingLeave={onMeetingLeave} customerName={customerName} userName={userName} />
        )}
      </MeetingConsumer>
    </MeetingProvider>
  ) : (
    <JoinScreen getMeetingAndToken={getMeetingAndToken} />
  );
}

export default App;